import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'component/Breadcrumb'

const OccurrencesCode8Header = (props) => {
  const { translate, pageName } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      {
        link: '/occurrences-code8',
        title: translate('occurrences-code8.title'),
      },
      { title: pageName },
    ]

    return <Breadcrumb steps={steps} />
  }

  return renderBreadcrumb()
}

OccurrencesCode8Header.propTypes = {
  translate: PropTypes.func.isRequired,
  pageName: PropTypes.string,
}

export default OccurrencesCode8Header
